@if (chartOptions(); as options) {
    <ag-charts style="height: 100%; display: flex" [options]="options"> </ag-charts>
}
